module.exports = __webpack_public_path__ + "static/media/rocks.511b6398.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/rocks.jpg
// module id = 619
// module chunks = 0